import { takeLatest, call } from '@redux-saga/core/effects'
import { put, select } from 'redux-saga/effects'
import { IOptionsResponse } from '../../../common/common.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors/getServiceId.selector'
import { OptionsService } from '../services/options.service'
import { setSctMedsOptions } from '../store/options.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* getSctMedsOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)

  try {
    const sctMedsOptionsResponse: IOptionsResponse = yield call([optionsService, optionsService.getSctMedsOptions])
    const { entity } = sctMedsOptionsResponse
    yield put(setSctMedsOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getSctMedsOptions() error: ${e}`))
  }
}

export function* getSctMedsOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getSctMedsOptions)
}
